<script>
  export let image
</script>

<style>
  .message {
    width: 100%;
  }
</style>

<svg
  class="message"
  width="100%"
  height="100%"
  viewBox="0 0 214 83"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <defs>
    <pattern id="image" x="0%" y="0%" height="100%" width="100%" viewBox="0 0 512 512">
      <image x="0%" y="0%" width="512" height="512" xlink:href={image} />
    </pattern>
  </defs>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M39 12C27.9543 12 19 20.9543 19 32L19 45C29.4934 45 38 53.5066 38 64C38 66.472 37.5279 68.8338 36.669 71H175C186.046 71 195 62.0457 195 51V22C195 16.4772 190.523 12 185 12H39Z"
    fill="white" />
  <circle cx="19" cy="64" r="18" fill="url(#image)" />
</svg>
